'use strict';
var _ = require('lodash');
var React = require('react');
var SectionHeader = require('../SectionHeader.jsx').default;
var Formatter = require('./../../../utils/Formatter.js');
var InSpecieTransferHelper = require('./../../../utils/InSpecieTransferHelper.js').default;
var InvestmentAllocationItem = require('./InvestmentAllocationItem.jsx');
var AllocationChart = require('./../AllocationChart.jsx').default;
var appConstants = require('../../../constants/ApplicationConstants.js');
var ProductIds = appConstants.ProductIds;

import { FirstRateSaverNonAutoRebalancing,FirstRateCashNonAutoRebalancing, FirstRateTTRSaverNonAutoRebalancing } from '../../../constants/InvestmentAllocationConstants';

var InvestmentAllocation = React.createClass({
    propTypes: {
        content: React.PropTypes.object.isRequired,
        investmentOptions: React.PropTypes.array.isRequired,
        investmentOptionsExternalOnly: React.PropTypes.array,
        allocations: React.PropTypes.array.isRequired,
        allocationsExternalOnly: React.PropTypes.array,
        sectionId: React.PropTypes.string.isRequired,
        sectionName: React.PropTypes.string.isRequired,
        sectionMessage: React.PropTypes.string,
        inSpecieData: React.PropTypes.object.isRequired,
        isPensionInSpecieTransfer: React.PropTypes.bool.isRequired,
        investmentOptionsExternalOnlyAmount: React.PropTypes.number.isRequired,
        investmentOptionsTotalAmount: React.PropTypes.number.isRequired,
        aggregatedAllocationsForPieChart: React.PropTypes.array.isRequired,
        inSpecieNotification: React.PropTypes.string,
        assetAllocationNotification: React.PropTypes.string,
        isFirstRateCashNonAutoRebalancing: React.PropTypes.bool,
        isPreRetirement: React.PropTypes.bool,
        productId: React.PropTypes.number.isRequired
    },

    getDefaultProps: function() {
        sectionMessage: ''
    },

    getAllocationAsset: function(invAllocId, assets) {
        var allocationsPerInvestment = _.filter(assets, { investmentOptionId: invAllocId, rateType: 'B' });
        return allocationsPerInvestment;
    },

    getInvestmentAllocationTotal(totalAmount) {
        const totalAmountFormatted = Formatter.currencyFormat(totalAmount, true);
        return(
            <section className="confirm-investment-allocation__total" key="confirm-investment-allocation__total">
                <div className="row componentBoxSpacing">
                    <div className="col-xs-offset-6 col-md-offset-8 col-xs-3 col-md-2 text-right">Total</div>
                    <div className="col-xs-3 col-md-2 confirm-investment-allocation__totalAmount">
                        {totalAmountFormatted}
                    </div>
                </div>
            </section>
        );
    },

    getInSpecieNotification() {
        if (this.props.inSpecieNotification) {
            return <p className="confirm-investment-allocation__inSpecieInvestmentAllocationMessage"
                      key="iai_inSpecieInvestmentAllocationMessage"
                      dangerouslySetInnerHTML={{ __html: this.props.inSpecieNotification }}></p>
        }
        return null;
    },

    getCashBucketOptions() {
        if(!this.props.isFirstRateCashNonAutoRebalancing) return null;

        let content = [];
        
        let cashBucketOptions = this.props.isPensionInSpecieTransfer ? this.props.investmentOptionsExternalOnly : this.props.investmentOptions;        

        cashBucketOptions = cashBucketOptions.filter(x => x.termDeposit || x.id == FirstRateSaverNonAutoRebalancing || x.id == FirstRateCashNonAutoRebalancing || x.id == FirstRateTTRSaverNonAutoRebalancing);                

        const allocations = this.props.isPensionInSpecieTransfer ? this.props.allocationsExternalOnly : this.props.allocations;

        _.each(cashBucketOptions,
            (item, idx) => {
                const assetAllocations = this.getAllocationAsset(item.id, allocations);
                content.push(
                    <div key={`iai_${idx}_row`} className="cia-row">
                        <InvestmentAllocationItem key={`iai_${idx}_row`} assetAllocations={assetAllocations}
                                                  amount={item.balance} name={item.name} code={item.code}
                                                  weight={item.weight} number={idx}/>
                    </div>
                );
            });
               
        return content;
    },

    getInvestmentOptionAllocationList() {
        const isVisible = InSpecieTransferHelper.isInvestmentOptionAllocationListVisible(this.props.isPensionInSpecieTransfer, this.props.inSpecieData);

        if (!isVisible) {
            return null;
        }

        let content = [];
        
        // refer to https://confluence.prod.cba/display/FAM/NOA-XXX+-+%5BIn+specie+transfer%5D+Enable+In+Specie+transfer+functionality
        // investment option list will only should external investment options for pension inSpecie
        let investmentOptions = this.props.isPensionInSpecieTransfer ? this.props.investmentOptionsExternalOnly : this.props.investmentOptions;
        let noOfCashBucketOptions = 0;

        if(this.props.isFirstRateCashNonAutoRebalancing) {

            noOfCashBucketOptions = investmentOptions.filter(x => x.termDeposit || x.id == FirstRateSaverNonAutoRebalancing || x.id == FirstRateCashNonAutoRebalancing || x.id == FirstRateTTRSaverNonAutoRebalancing).length;
            investmentOptions = investmentOptions.filter(x => !x.termDeposit && x.id != FirstRateSaverNonAutoRebalancing && x.id != FirstRateCashNonAutoRebalancing && x.id != FirstRateTTRSaverNonAutoRebalancing);
        }

        const totalAmount = this.props.isPensionInSpecieTransfer ? this.props.investmentOptionsExternalOnlyAmount : this.props.investmentOptionsTotalAmount;
        const allocations = this.props.isPensionInSpecieTransfer ? this.props.allocationsExternalOnly : this.props.allocations;
        _.each(investmentOptions,
            (item, idx) => {
                const index = noOfCashBucketOptions === 0 ? idx : (noOfCashBucketOptions + idx);
                const assetAllocations = this.getAllocationAsset(item.id, allocations);
                content.push(
                    <div key={`iai_${idx}_row`} className="cia-row">
                        <InvestmentAllocationItem key={`iai_${idx}_row`} assetAllocations={assetAllocations}
                                                  amount={item.balance} name={item.name} code={item.code}
                                                  weight={item.weight} number={index}/>
                    </div>
                );
            });
        
        if (investmentOptions.length > 0) {
            const invTotal = this.getInvestmentAllocationTotal(totalAmount);
            content.push(invTotal);
        }

        if (this.props.isConsolidatedTd) {
            content.push(<p className="confirm-investment-allocation__consolidatedTdMessage" key="iai_consolidatedTdMessage">{this.props.content.consolidatedTermDeposit}</p>);
        }

        return content;
    },

    getAssetAllocationNotification() {
        if (this.props.assetAllocationNotification) {
            return(<p className="confirm-investment-allocation__noAllocationsMessage" key="iai_noAllocationsMessage">
                       {this.props.assetAllocationNotification}
                   </p>);
        }
        return null;
    },

    getAssetAllocationPieChart() {
        const isVisible = InSpecieTransferHelper.isAssetAllocationPieChartVisible(this.props.isPensionInSpecieTransfer, this.props.inSpecieData);

        if (!isVisible) {
            return null;
        }
        
        return(<AllocationChart key="allocation-chart" totalAmount={this.props.investmentOptionsTotalAmount}
                 aggregatedAllocations={this.props.aggregatedAllocationsForPieChart}
                 message={this.props.content.investmentAllocationChartMessage}
                 title={this.props.content.investmentAllocationChartTitle}/>);
    },

    getManagedAccountName() {
        if (this.props.managedAccountName) {
            return (<div key="iai_managedAccountName" className="confirm-investment-allocation__managedAccountName confirm-simple-review">
                        <div className="row simple-review-row">
                            <div className="col-xs-12">
                                <span className="simple-review-value">Portfolio {this.props.managedAccountName}</span>
                            </div>
                        </div>
                    </div>);
        }
        return null;
    },

    getOtherInvestmentsTitle() {
        if (this.props.isFirstRateCashNonAutoRebalancing && !this.props.managedAccountName) {
            return (<div key="iai_otherInvestments" className="confirm-investment-allocation__otherOptions confirm-simple-review">
                        <div className="row simple-review-row">
                            <div className="col-xs-12">
                                <span className="simple-review-value">Other Investment Options(s)</span>
                            </div>
                        </div>
                    </div>);
        }
        return null;
    },

    getCashBucketStrategyTitle() {
        let investmentAllocationTitle = '';

        if(this.props.productId === ProductIds.PENSION && this.props.isPreRetirement){
            investmentAllocationTitle='FirstRate TTR Saver Non-Auto-rebalancing option';
        }else if(this.props.productId === ProductIds.PENSION && !this.props.isPreRetirement){
            investmentAllocationTitle='FirstRate Saver Non-Auto-rebalancing option or term deposits';
        }else if(this.props.productId === ProductIds.INVESTMENT){
            investmentAllocationTitle='FirstRate Cash Non-Auto-rebalancing option';
        }else if(this.props.productId === ProductIds.SUPER){
            investmentAllocationTitle='FirstRate Saver Non-Auto-rebalancing option or term deposits';
        }

        if (this.props.isFirstRateCashNonAutoRebalancing) {
            return (<div key="iai_firstRateCashNonAutoRebalancing" ref="cashBucketTitle" className="confirm-investment-allocation__cashbucket confirm-simple-review">
                        <div className="row simple-review-row">
                            <div className="col-xs-12">
                                <span className="simple-review-value">{investmentAllocationTitle}</span>
                            </div>
                        </div>
                    </div>);
        }
        return null;
    },

    render() {
        let content = [];
        
        // show investment allocation messages for inspecie
        const investmentAllocationNote = this.getInSpecieNotification();
        if (investmentAllocationNote) {
            content.push(investmentAllocationNote);
        }

        // show cash bucket title if cash bucket strategy is selected
        const cashBucketStrategyTitle = this.getCashBucketStrategyTitle();
        if (cashBucketStrategyTitle) {
            content.push(cashBucketStrategyTitle);
        }

        // rules to show cash bucket funds Table
        const cashOptionsList = this.getCashBucketOptions();
        if (cashOptionsList) {
            content.push(cashOptionsList);
        }

        // show managed account name if a managed account is selected
        const managedAccountName = this.getManagedAccountName();
        if (managedAccountName) {
            content.push(managedAccountName);
        }

         // show otherInvestmentsTitle if a cash bucket strategy is selected
         const otherInvestmentsTitle = this.getOtherInvestmentsTitle();
         if (otherInvestmentsTitle) {
             content.push(otherInvestmentsTitle);
         }

        // rules to show Allocation Table
        const investmentAllocationList = this.getInvestmentOptionAllocationList();
        if (investmentAllocationList) {
            content.push(investmentAllocationList);
        }

        if (this.props.hasAllocations) {
            // show asset allocation messages
            const assetAllocationNote = this.getAssetAllocationNotification();
            if (assetAllocationNote) {
                content.push(assetAllocationNote);
            }

            // rules to show Allocation Piechart
            const assetAllocationPieChart = this.getAssetAllocationPieChart();
            if (assetAllocationPieChart) {
                content.push(assetAllocationPieChart);
            }
        } else {
            content.push(
                <p className="confirm-investment-allocation__noAllocationsMessage" key="iai_noAllocationsMessage">
                    {this.props.content.assetAllocationNotAvailable}
                </p>);
        }

        return (
            <section className="confirm-investment-allocation" key="confirm-investment-allocation" id={this.props.sectionId}>
                    <div className="container">
                        <SectionHeader sectionId={this.props.sectionId} handlePencilClick={this.props.handlePencilClick} 
                                       sectionName={this.props.sectionName} sectionMessage={this.props.sectionMessage} />
                        {content}
                    </div>
                </section>
            ); 
    }
});

module.exports = InvestmentAllocation;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/InvestmentAllocation/InvestmentAllocation.jsx